/**
 * Diagram modals: no credits, person not found.
 * Uses jQuery and modal elements (no_credits_error_modal, data_not_available_error_modal).
 */

function showNoCreditsModal() {
  if (typeof no_credits_error_modal !== 'undefined' && typeof $ !== 'undefined') {
    $(no_credits_error_modal).modal('show');
  }
}

function showPersonNotFoundModal() {
  if (typeof data_not_available_error_modal !== 'undefined' && typeof $ !== 'undefined') {
    $(data_not_available_error_modal).modal('show');
  }
}

export { showNoCreditsModal, showPersonNotFoundModal };
